document.documentElement.classList.remove('no-js')

const body = document.body
const cursor = document.querySelector('.cursor-glow')

if (cursor && body.classList.contains('cursor-allowed') && window.matchMedia('(pointer: fine)').matches && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  body.classList.add('cursor-enabled')
  window.addEventListener('pointermove', (event) => {
    cursor.style.left = `${event.clientX}px`
    cursor.style.top = `${event.clientY}px`
  }, { passive: true })
}

const revealItems = document.querySelectorAll('[data-reveal]')

if ('IntersectionObserver' in window) {
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible')
        revealObserver.unobserve(entry.target)
      }
    })
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 })
  revealItems.forEach((item) => revealObserver.observe(item))
} else {
  revealItems.forEach((item) => item.classList.add('is-visible'))
}

const header = document.querySelector('[data-site-header]')

const updateHeader = () => {
  if (!header) return
  header.classList.toggle('is-scrolled', window.scrollY > 44)
}

updateHeader()
window.addEventListener('scroll', updateHeader, { passive: true })

document.querySelectorAll('[data-close-details]').forEach((button) => {
  button.addEventListener('click', () => {
    const details = button.closest('details')
    if (details) details.removeAttribute('open')
  })
})

document.querySelectorAll('[data-lume-reveal]').forEach((reveal) => {
  const input = reveal.querySelector('input[type="range"]')
  if (!input) return
  const updateReveal = () => reveal.style.setProperty('--reveal', `${input.value}%`)
  input.addEventListener('input', updateReveal)
  updateReveal()
})

document.querySelectorAll('[data-quantity-minus], [data-quantity-plus]').forEach((button) => {
  button.addEventListener('click', () => {
    const field = button.closest('.quantity-field')
    const input = field ? field.querySelector('input') : null
    if (!input) return
    const step = button.hasAttribute('data-quantity-plus') ? 1 : -1
    input.value = Math.max(Number(input.min || 1), Number(input.value || 1) + step)
    input.dispatchEvent(new Event('change', { bubbles: true }))
  })
})

document.querySelectorAll('[data-variant-select]').forEach((select) => {
  select.addEventListener('change', () => {
    const price = select.options[select.selectedIndex].dataset.price
    const productInfo = select.closest('.product-info')
    const priceTarget = productInfo ? productInfo.querySelector('[data-product-price] span') : null
    const buttonPrice = productInfo ? productInfo.querySelector('.product-form__submit span') : null
    if (priceTarget && price) priceTarget.textContent = price
    if (buttonPrice && price) buttonPrice.textContent = price
  })
})

document.querySelectorAll('[data-sort-select]').forEach((select) => {
  select.addEventListener('change', () => select.form.submit())
})
